import React from 'react';
import TopicSection from './TopicSection';
import TopicItem from './TopicItem';
import { Wrapper, MainTitle, MainTitleContainer } from './TopicSummary.styles';
import Clipboard from '../../images/icons/Clipboard.svg';

const TopicSummary = ({ topicSummary, onViewPhotos, hasPhotosInGallery }) => {
  if (!topicSummary) {
    return null;
  }

  const { cautelar, pintura, pneus, motorCambio, luzAdvertencia, opcionais } = topicSummary;

  const isNonEmptyArray = arr => Array.isArray(arr) && arr.length > 0;

  const getMotorCambioColumns = () => {
    const good = motorCambio.filter(item => !item.needsAttention);
    const bad = motorCambio.filter(item => item.needsAttention);
    return { good, bad };
  };

  const hasPintura = isNonEmptyArray(pintura);
  const hasPneus = isNonEmptyArray(pneus);
  const hasMotorCambio = isNonEmptyArray(motorCambio);
  const hasOpcionais = Array.isArray(opcionais)
    ? opcionais.some(op => isNonEmptyArray(op?.items))
    : false;

  const motorCambioColumns = hasMotorCambio ? getMotorCambioColumns() : null;

  const getAllPhotos = items => items.reduce((acc, item) => [...acc, ...(item.photos || [])], []);

  const newCautelar = Array.isArray(cautelar) ? cautelar : cautelar ? [cautelar] : [];
  const hasCautelar = isNonEmptyArray(newCautelar);

  const newCautelarPhotos = Array.isArray(cautelar)
    ? cautelar.map(item => item.photos)
    : cautelar?.photos;

  return (
    <Wrapper>
      <MainTitleContainer>
        <img src={Clipboard} />
        <MainTitle>Resumo do carro</MainTitle>
      </MainTitleContainer>

      {hasCautelar && (
        <TopicSection
          title="Cautelar"
          items={newCautelar}
          photos={newCautelarPhotos}
          onViewPhotos={onViewPhotos}
          hasPhotosInGallery={hasPhotosInGallery}
        />
      )}

      {hasPintura && (
        <TopicSection
          title="Pintura"
          items={pintura}
          photos={getAllPhotos(pintura)}
          onViewPhotos={onViewPhotos}
          hasPhotosInGallery={hasPhotosInGallery}
        />
      )}

      {hasPneus && (
        <TopicSection
          title="Pneus"
          items={pneus}
          photos={getAllPhotos(pneus)}
          onViewPhotos={onViewPhotos}
          hasPhotosInGallery={hasPhotosInGallery}
        />
      )}

      {hasMotorCambio && motorCambioColumns && (
        <TopicSection
          title="Motor e Câmbio"
          photos={getAllPhotos(motorCambio)}
          twoColumns
          firstColumnItems={motorCambioColumns.good}
          secondColumnItems={motorCambioColumns.bad}
          onViewPhotos={onViewPhotos}
          hasPhotosInGallery={hasPhotosInGallery}
        />
      )}

      {luzAdvertencia && (
        <TopicSection
          title="Luz de advertência"
          items={[luzAdvertencia]}
          photos={luzAdvertencia.photos}
          onViewPhotos={onViewPhotos}
          hasPhotosInGallery={hasPhotosInGallery}
        />
      )}

      {hasOpcionais &&
        opcionais.map(
          opcional =>
            isNonEmptyArray(opcional?.items) && (
              <TopicSection
                key={opcional.type}
                title={`Opcionais de ${opcional.type}`}
                items={opcional.items}
                photos={getAllPhotos(opcional.items)}
                twoColumns
                onViewPhotos={onViewPhotos}
                hasPhotosInGallery={opcional.type === 'conforto' ? hasPhotosInGallery : null}
              />
            )
        )}
    </Wrapper>
  );
};

export default TopicSummary;
